import { Panel } from "../../../../components/panels/Panel";


export const DiorDataDashboardGeneralDataBlock = ({ dataName, value, unitText, trend }) => {

  return (
    <Panel noHeader rounded category="secondary">
      <div className="flex flex-col gap-4">
        <div className="text-perception-gray-600">
          {dataName}
        </div>
        <div className="flex gap-2 items-baseline">
          <div className="text-3xl">
            {value}
          </div>
          <div className="text-sm">
            {unitText}
          </div>
          {trend &&
            <div className={`text-sm font-semibold ${trend > 0 ? 'text-perception-success-600' : 'text-perception-error-500'}`}>
              {trend > 0 ? `+${trend}` : trend}%
            </div>
          }
        </div>
      </div>
    </Panel>
  );
};